import { UserModel } from "@/app/entities";
import {
  DashboardHeader,
  SideImageCard,
  UiBadge,
  UiButton,
} from "@/components";
import { ArrowLeft, Edit, Goal } from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useToast } from "@/composables/toast";
import { useUsers } from "@/composables/users";
import { RowInformation } from "@/components/atoms/list";
import { formatAppDate, formatAppDateTime } from "@/utils";

export default function UserDetailPage() {
  const navigate = useNavigate();
  const { matricule } = useParams<{ matricule: string }>();
  const { loading, getUserByMatricule } = useUsers();

  const [user, setUser] = useState<UserModel | null>(null);

  useEffect(() => {
    if (!matricule) {
      navigate(-1);
      return;
    }
    const theUser = getUserByMatricule(matricule);
    if (!theUser) {
      useToast("Utilisateur introuvable", {
        variant: "error",
      });
      return;
    }
    setUser(theUser);
  }, [matricule]);

  return (
    <div>
      <DashboardHeader subTitle="Bienvenue aux campagnes" />

      <div className="py-4">
        {user && (
          <SideImageCard
            loading={loading}
            imgSrc="/assets/images/chris-lee-70l1tDAI6rM-unsplash 1.png"
          >
            <div className="">
              <UiButton
                variant="text"
                onClick={() => navigate(-1)}
                startIcon={<ArrowLeft />}
              >
                Retour
              </UiButton>
            </div>

            <div className="p-4  w-full">
              <h1 className="text-2xl pb-4 form-title">
                {" "}
                {user?.prenom ?? ""} {user?.nom ?? ""}
              </h1>

              <label className="ui-form-label flex gap-2 items-center mb-1">
                Adresse
              </label>
              <div className="p-2 border border-gray-200 rounded-md mb-4">
                {user?.adresse?.pays ?? ""} {user?.adresse?.intituleRue ?? ""}{" "}
                {user?.adresse?.adresseComplete ?? ""}
              </div>

              <RowInformation label="Matricule" value={user?.matricule ?? ""} />
              <RowInformation label="Téléphone" value={user?.phone ?? ""} />
              <RowInformation label="Email" value={user?.email ?? ""} />
              <RowInformation
                label="Ville de naissance"
                value={user?.villeNaissance ?? ""}
              />
              <RowInformation
                label="Ville d'activité"
                value={user?.villeActivite ?? ""}
              />
              <RowInformation label="Type" value={user?.type ?? ""} />

              <RowInformation
                label="Date de naissance"
                value={formatAppDate(user?.dateNaissance ?? "")}
              />
              <RowInformation
                label="Date de dernière connexion"
                value={formatAppDateTime(user?.derniereConnexion ?? "")}
              />
              <RowInformation
                label="Date de mise à jour"
                value={formatAppDateTime(user?.dateMiseAJour ?? "")}
              />

              <RowInformation
                label="Statut"
                value={
                  <UiBadge variant={user?.disabled ? "inactive" : "active"}>
                    {user?.disabled ? "Bloqué" : "Actif"}
                  </UiBadge>
                }
                className="my-2 py-2"
              />
            </div>
          </SideImageCard>
        )}
      </div>
    </div>
  );
}
